import flatten from 'lodash/flatten';

import { cssSelectorForElement, isInvalidElement } from '@candu-ai/placement/utils';

export const isSelectableNode = (node: Element | null) =>
  !node?.getAttribute?.(`data-candu-slug`) &&
  node?.nodeType === 1 &&
  !isInvalidElement(node.tagName);

export const getNode = (selector?: string) =>
  selector ? document.querySelectorAll(selector)?.[0] : null;

export const nodeLayerScale = (nthLayerDisplayed: number) => {
  if (nthLayerDisplayed > 14) {
    return 'xsmall';
  }
  if (nthLayerDisplayed > 7) {
    return 'small';
  }
  return 'normal';
};

export const getMaxNth = (
  nodeId: string | undefined,
  expandedNodes: Record<string, boolean>,
  length = 0,
): number => {
  const node = getNode(nodeId);
  if (nodeId && expandedNodes[nodeId] && node?.childElementCount) {
    return Array.from(node.childNodes).reduce((maxLength: number, childNode: HTMLElement) => {
      const nodeSelector = cssSelectorForElement(childNode || '');
      const childNodeDepth = getMaxNth(nodeSelector, expandedNodes, length + 1);

      return Math.max(maxLength, childNodeDepth);
    }, length);
  }
  return length;
};

export const inOrderTraversal = (nodeId: string | undefined): string[] => {
  if (!nodeId) {
    return [];
  }
  const node = getNode(nodeId);
  if (!node) {
    return [];
  }

  if (!node.childNodes) {
    return [nodeId];
  }
  const nodesTraversal: string[][] = Array.from(node.childNodes).map((childId: HTMLElement) =>
    inOrderTraversal(cssSelectorForElement(childId || '')),
  );
  return [nodeId, ...flatten(nodesTraversal)];
};

export const isLastNodeOfParent = (nodeId: string) => {
  if (nodeId === 'body') {
    return false;
  }
  const node = getNode(nodeId);

  return (
    node?.parentElement &&
    Array.from(node.parentElement.childNodes).findIndex(
      (childNode: HTMLElement) => nodeId === cssSelectorForElement(childNode),
    ) ===
      Array.from(node.parentElement.childNodes).length - 1
  );
};
